import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'
import { getUserData } from '@/auth/utils'

export default function useUsersList(){

    const toast = useToast()

    const refUserListTable = ref(null)

    // Users table contains column User Code / User Name / Status / Created at / Action
    const tableColumns = [
        { key: 'id', sortable: true },
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'store.name', label: 'STORE'},
        { key: 'actions'}
    ]
    const perPage = ref(10)
    const totalUsers = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUsers.value,
        }
    })

    const refetchData = () =>{
        refUserListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchUsers = (ctx, callback) => {

        store.dispatch('setting-user/fetchUsers', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { users, total } = response.data
            callback(users)
            totalUsers.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching users list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                },
            })
        })

    }

    // 檢查是否應該顯示 Actions 欄位
    const shouldShowActions = (item) => {
        const currentUser = getUserData();
        // 如果表格項目不是管理員（is_admin 不為 true 或 1），則始終顯示 Actions
        if (!item.is_admin) {
            return true;
        }
        // 如果表格項目是管理員（is_admin 為 true 或 1），則只有當登入使用者的 ID 等於表格項目的 ID 時，才顯示 Actions
        return currentUser && currentUser.id === item.id;
    }

    return {
        fetchUsers,
        tableColumns,
        perPage,
        currentPage,
        totalUsers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refUserListTable,
        ability,
        shouldShowActions
    }


}